<template>
	<div class="rt">
		<div class="right">
			<div class="box-max">
				<div class="control cl-left ">
					<img class="box-bg zoomInOut-element" src="../../assets/template/control-left.png" alt="">
					<div class="cl-left-text ">
						<span class="cl-left-text-num">00</span>
						<span class="cl-left-text-unit">%</span>
						<p>线上占比</p>
					</div>

				</div>
				<div class="control cl-center">
					<div class="cl-center-Top"></div>
				</div>
				<div class="control cl-right ">
					<img class="box-bg zoomInOut-element" src="../../assets/template/control-right.png" alt="">
					<div class="cl-right-text ">
						<span class="cl-right-text-num">00</span>
						<span class="cl-right-text-unit">%</span>
						<p>线下占比</p>
					</div>
				</div>
			</div>
			<img class="box-bg rotateXZ-element" src="../../assets/template/control.png" alt="">
			<!-- <div ref="rightTop" class="rightTop" :style="{ width: '480px', height: '240px' }"></div> -->
		</div>
	</div>
</template>

<script>

export default {
	name: 'template.rightTop',
	data() {
		return {
			myChart: "",
			option: "",
			TmyChart: "",
			Toption: "",
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {
		cDrawCircle() {
			var echarts = require('echarts');
			// var TmyChart = echarts.init(this.$refs.rightTop);
			var Toption = {

			};
			Toption && TmyChart.setOption(Toption);
			setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	mounted() {
		this.$nextTick(() => {
			// this.cDrawCircle(); //需要刷新的数据
		});
	},
};
</script>

<style scoped lang="scss">
@import '../../css/animation.css';

@font-face {
	font-family: "Source Han Sans CN";
	src: url("../../assets/fonts/SourceHanSansCN-Medium.woff2");
}

@font-face {
	font-family: "Benmo-Ziyu";
	src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.rt {
	width: 480px;
	height: 240px;
	padding: 10px 0;
	display: flex;
	position: relative;
}

.right {

	width: 480px;
	height: 240px;
	margin: 16px 0 0 118px;
	position: relative;
}

.box-max {
	width: 211px;
	height: 211px;
	// background: url('../../assets/template/control.png') no-repeat;
	// background-size: 100%;
	z-index: 1;
}

.box-bg {
	width: 211px;
	height: 211px;
	z-index: 1;
	position: absolute;
	top: 0%;
}

.control img {
	width: 114px;
	height: 196px;
	z-index: 1;
	position: absolute;
	top: 0%;
}

.cl-left {
	width: 114px;
	height: 196px;
	// background: url('../../assets/template/control-left.png') no-repeat;
	// background-size: 100% 100%;
	position: absolute;
	// z-index: 50;
	top: 5px;
	left: -94px;

	.cl-left-text {
		padding: 80px 24px;
		position: relative;
		z-index: 10 !important;

		&-num {
			display: inline-block;
			width: 27px;
			height: 18px;
			font-family: Benmo-Ziyu;
			font-weight: 400;
			font-size: 20px;
			color: #FFFFFF;
			line-height: 15px;
		}

		&-unit {
			width: 13px;
			height: 11px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-left: 3px
		}

		p {
			width: 58px;
			height: 13px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-top: 12px;
		}
	}

}

.cl-center {
	width: 76px;
	height: 76px;
	border-radius: 50%;
	border: 1px solid #004ADB;
	position: relative;
	top: 68px;
	left: 69px;

	.cl-center-Top {
		width: 38px;
		height: 34px;
		background: url('@/assets/template/xiaoshoue.png') no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 50;
	}
}

.cl-right {
	width: 114px;
	height: 196px;
	// background: url('../../assets/template/control-right.png') no-repeat;
	// background-size: 100% 100%;
	position: absolute;
	// z-index: 50;
	top: 5px;
	left: 195px;

	.cl-right-text {
		padding: 80px 34px;
		position: relative;
		z-index: 10 !important;

		&-num {
			display: inline-block;
			width: 27px;
			height: 18px;
			font-family: Benmo-Ziyu;
			font-weight: 400;
			font-size: 20px;
			color: #FFFFFF;
			line-height: 15px;
		}

		&-unit {
			width: 13px;
			height: 11px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-left: 2px;
		}

		p {
			width: 58px;
			height: 13px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-top: 12px;
		}
	}


}




.rightTop {
	// position: absolute;
	// top: -35px;
	// left: -137px;
	z-index: 5;
}


.bt-icon {
	position: absolute;
	width: 30px;
	height: 30px;
	left: 36px;
	top: 14px;
}
</style>